import { render, staticRenderFns } from "./community.vue?vue&type=template&id=e4018be8&scoped=true&"
import script from "./community.vue?vue&type=script&lang=js&"
export * from "./community.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4018be8",
  null
  
)

export default component.exports